import { VilState } from './VilState';

export const stores = [
  VilState
];



// WEBPACK FOOTER //
// ./src/shared/stores/vil/index.js